import {color} from '../constants/color'

const getStartPoint = (trajectory) => {
  return {
    lat: trajectory[0].location.latitude,
    lng: trajectory[0].location.longitude,
  };
};

const getEndPoint = (trajectory) => {
  const endLocation = trajectory[trajectory.length - 1].location;

  return {
    lat: endLocation.latitude,
    lng: endLocation.longitude,
  };
};

const getCarPoint = (trajectory) => {
  return {
    lat: trajectory[0].location.latitude,
    lng: trajectory[0].location.longitude,
  };
};

export const getStartEndPoints = (transport) => {
  const trajectory = transport.timelineEvent.trajectory;

  return {
    start: getStartPoint(trajectory),
    end: getEndPoint(trajectory),
    car: getCarPoint(trajectory),
  };
};

// get speeding polylines for map
export const getSpeedingLineStrings = (array) => {
  var result = [];
  for (var arr, i = 0; i < array.length; i++) {
    if (array[i].speedV2 < array[i].speedLimit) {
      arr = null;
    } else {
      if (!arr) result.push((arr = []));
      arr.push({
        lat: array[i].location.latitude,
        lng: array[i].location.longitude,
        speed: array[i].speedV2,
        averageSpeed: (array[i].speedV2+array[i-1].speedV2)/2
      });
    }
  }
  return result;
};

// return type of traffic at the time of crash
const getTrafficType = (trafficData) => {
  if ((trafficData.currentSpeed / trafficData.freeFlowSpeed) * 100 >= 80) {
    return "Good";
  } else if (
    (trafficData.currentSpeed / trafficData.freeFlowSpeed) * 100 < 80 &&
    (trafficData.currentSpeed / trafficData.freeFlowSpeed) * 100 >= 40
  ) {
    return "Moderate";
  } else {
    return "Traffic";
  }
};

// return array of traffic on the road when crash happened
export const getTrafficLineStrings = (array) => {
  var arrayTraffic = array.map((a) => ({
    type: getTrafficType(a),
    path: a.path.map((p) => ({ lat: p.latitude, lng: p.longitude })),
    speed: a.currentSpeed,
    averageSpeed: a.freeFlowSpeed
  }));
  return arrayTraffic;
};

//return color of polyline
export const getStrokeColor = (type) => {
  return type === "Moderate"
    ? color.moderate
    : type === "Good"
    ? color.green
    : color.red;
};
